import { FC, useState, ReactNode, useRef, useEffect } from "react";
import { HeaderCarousel } from "./HeaderCarousel";
import { AnimatePresence, motion } from "motion/react";
import { NavLink } from "react-router";
import Home from "../../assets/icons/home.svg?react";
import MusicNote from "../../assets/icons/music-note.svg?react";
import Reel from "../../assets/icons/reel.svg?react";
import Users from "../../assets/icons/users.svg?react";
import CalendarHeart from "../../assets/icons/calendar-heart.svg?react";
import Document from "../../assets/icons/document.svg?react";
import Award from "../../assets/icons/award.svg?react";
import ArrowDown from "../../assets/icons/arrow-down.svg?react";
import Location from "../../assets/icons/location.svg?react";
import { Select } from "../ui/Select";
import { Station } from "../../types/station";

export type NavItem = {
    label: string;
    icon: ReactNode;
    path: string;
}

type NavigationBarProps = {
    station?: Station;
    stations?: Array<Station>;
    onClickNavItem: (item: NavItem) => void;
    onClickRJ?: () => void;
    onSelectStation?: (station: Station) => void;
}
const talentHunts = [
    {
        name: 'College Ke Tashanbaaz',
        id: 1,
        link: 'https://www.collegeketashanbaaz.in/',
        stationIds: [1,2,4,5,6,7,8,9,10,11,12,14,34,35,36,37,38,40,41,42,45,46,47,48,49,50,51,52,55,56,57,58]
    },
    // {
    //     name: 'another event',
    //     id: 1,
    //     link: ''
    // }
]

const navItems: Array<NavItem> = [{ label: 'Home', icon: <Home />, path: 'home' }, { label: 'Audio', icon: <MusicNote />, path: 'audio' }, { label: 'Video', icon: <Reel />, path: 'video' }, { label: 'RJs', icon: <Users />, path: 'rjs' }, { label: 'Events', icon: <CalendarHeart />, path: 'events' }, { label: 'Red Lines News', icon: <Document />, path: 'redlines' }, { label: 'Talent Hunt', icon: <Award />, path: 'talent-hunt' }];

export const NavigationBar: FC<NavigationBarProps> = ({ station, stations = [], onClickNavItem, onClickRJ, onSelectStation }) => {
    const [active, setActive] = useState<string>('');

    const navItemRef = useRef<HTMLDivElement>(null);
    const handleClickOutside = (event: MouseEvent) => {
       console.log('click outside', event);
        if (navItemRef.current && !navItemRef.current.contains(event.target as Node)) {
            setActive('');
        }
    };
    useEffect(() => {
        if (active) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [active]);

    const onNavItemClick = (event: React.MouseEvent<HTMLAnchorElement>, item: NavItem) => {
        if (item.label === 'RJs' || item.label === 'Talent Hunt') event.preventDefault();
        setActive(active === 'RJs' || active === 'Talent Hunt' ? '' : item.label);
        onClickNavItem(item);
    }
    const isTalentHunt = talentHunts.some((talentHunt) => talentHunt.stationIds.includes(Number(station?.id)));
    return (
        <section className="p-1 md:p-0">
            <ul className="flex flex-col md:flex-row items-center">
                {
                    navItems.map((item, index) => {
                        if(!isTalentHunt && item.label === 'Talent Hunt') return null;
                        return (
                        <li key={index} className="relative w-full md:w-auto">
                            <NavLink to={item.path} type="button" className={({ isActive }) => `w-full md:w-auto flex items-center gap-4 text-left peer px-4 py-2.5 font-inter font-bold leading-5 md:hover:text-primary-700 transition-colors duration-500 ${isActive ? 'text-white md:text-primary-700 bg-[#2D2D2D] md:bg-inherit' : 'text-white font-normal md:font-bold'}`}
                             onClick={(event) => onNavItemClick(event, item)}
                             onMouseEnter={(event) => {
                                if(item.label === 'Talent Hunt') {
                                    onNavItemClick(event, item)}}
                                }
                             >
                                <span className="md:hidden text-primary-700">{item.icon}</span>
                                <div className="flex items-center gap-2">
                                    <p className="text-md  whitespace-nowrap">{item.label}</p>
                                    {item.label === 'RJs' && <ArrowDown className="hidden md:block" />}
                                    {item.label === 'Talent Hunt' && <ArrowDown className="hidden md:block" />}
                                </div>
                            </NavLink>
                            <div className="md:peer-hover:visible invisible bg-primary-700 h-0.5 peer-hover:w-full w-0 transition-all absolute left-1/2 -translate-x-1/2 duration-500"></div>
                            <AnimatePresence>
                                {
                                    active === 'RJs' && item.label === 'RJs' && (
                                        <motion.div className="md:hidden" key="s" initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.25 }}>
                                            <HeaderCarousel onClickProfile={() => { setActive(''); onClickRJ?.(); }} />
                                        </motion.div>
                                    )
                                }
                                {
                                    active === 'Talent Hunt' && item.label === 'Talent Hunt' && (
                                        <motion.div  ref={navItemRef}  className="md:absolute md:top-16 left-0 max-w-[300px] bg-black" key="1" initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.25 }}>
                                           <section className="flex flex-col md:gap-0 py-2">
                                                <div className="flex flex-col items-center px-4 z-10 gap-2">
                                                    {
                                                        talentHunts.filter((talentHunt) => talentHunt.stationIds.includes(Number(station?.id))).map((talentHunt) => (
                                                            <button className="cursor-pointer whitespace-nowrap font-inter leading-5 md:hover:text-primary-700 transition-colors duration-500 text-white font-normal md:font-bold"
                                                             key={talentHunt.id}
                                                            
                                                            onClick={() => {
                                                                setActive('');
                                                                window.open(talentHunt.link, '_blank') }}>{talentHunt.name}</button>
                                                        ))
                                                    }
                                                </div>
                                            </section>
                                        </motion.div>
                                    )
                                }
                            </AnimatePresence>
                        </li>
                    )}
                    )}
            </ul>
            <Select
                value="id"
                state="name"
                options={stations}
                selectedOption={station?.name}
                onSelect={onSelectStation}
                leadingIcon={<Location className="text-primary-700" />}
                variant="plain"
                width='w-auto'
                className="md:hidden px-1"
            />
        </section>
    )
}